import api from './api';

/** Pro-forma invoices of a job (admin, with the job's amounts shown). */
const ProformaService = {
    list: (jobId) => api.get(`/jobs/${jobId}/proformas`).then(r => r.data),
    get: (jobId, id) => api.get(`/jobs/${jobId}/proformas/${id}`).then(r => r.data),
    create: (jobId, payload) => api.post(`/jobs/${jobId}/proformas`, payload).then(r => r.data),
    update: (jobId, id, payload) => api.put(`/jobs/${jobId}/proformas/${id}`, payload).then(r => r.data),
    remove: (jobId, id) => api.delete(`/jobs/${jobId}/proformas/${id}`),
};

export default ProformaService;
